import {
    ApartmentOutlined,
    BarChartOutlined,
    CaretDownOutlined,
    CaretUpOutlined,
    DatabaseOutlined,
    DoubleLeftOutlined,
    DoubleRightOutlined,
    ImportOutlined,
    LogoutOutlined,
    SettingOutlined,
    TeamOutlined,
    UserOutlined
} from '@ant-design/icons';
import {Affix, Avatar, Layout, Menu, Row, Spin, Tooltip, Alert} from 'antd';
import 'antd/dist/antd.css';
import 'intro.js/introjs.css';
import {isEqual} from "lodash";
import {Component} from "react";
import cookie from "react-cookies";
import {connect} from "react-redux";
import {Link, Redirect, Route} from 'react-router-dom';
import "../asset/style/morpheus.css";
import ScannersListComp from "../component/dashboard/scannerspane";
import {LoadingText} from "../component/gammaviewer/components/components";
import BloodWorkflow from '../component/scanner/blood_workflow';
import BloodPreviewSettingsComp from '../component/scanner/scanWorkflow/previewSettingsComponentBlood';
import ScanWorkflowNew from '../component/scanner/scan_workflow_new';
import {PrivateRoute} from '../helper/private.route';
import {sagaMiddleware} from '../helper/store';
import {closeDrawer, openDrawer} from "../redux_actions/dashboard.action";
import {logout} from "../redux_actions/login.action";
import {loadMorpheusSetting} from "../redux_actions/morpheus.setting.action";
import {stopPollingForPollables, watchForPollables} from '../redux_actions/slides.action';
import {MorphleLogoBW, MorphleLogoSquare, responsiveLayers} from '../utils/const';
import {
    debounce,
    getRealRemoteURL,
    isCloud,
    isNull,
    isRunningFromSite,
    isSuperuser,
    isTrue,
    openEndPoint,
    openInNewTab,
    stringForAvatar
} from "../utils/utils";
import {
    checkAbstractAppPermission,
    showMfaAlert,
} from "../component/utils/abstract_app_maker";
import AddCaseView from '../view/addcase';
import AddValidationView from '../view/addvalidation';
import CasesView from '../view/casesview';
import ScannerView from '../view/scanner';
import SingleCaseView from '../view/singlecaseview';
import Devices from "./Devices";
import Disks from "./Disks";
import AddUserView from './adduser';
import CliaBarrier from './cliahome';
import CliaView from './cliaview';
import AllScansView from "./dashboard";
import MorphoChatDashboard from "./morphoChatDashboard";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import EditUserView from './edituser';
import LivePlot from './liveplot';
import ManageUsers from './manageusers';
import ScannerAnalysis from "./scannerAnalysis";
import ScanningProfileView from "./scanning_profile";
import SettingsView from './settings';
import SingleValidationView from './singlevalidationstudy';
import StatsDashboard from './statsDashboard';
import SummaryView from './summaryview';
import C240ControlPanelView from "./c240/c240_control_panel_view";
import validationStudies from './validationStudies';
import {tourGuideForDashboard} from './websiteTourUtils';

import {Button as MuiButton, Divider, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import AddPatientFolder from "view/addpatientfolder";
import PatientFolder from 'view/patientfolder';
import PatientFolderView from "view/patientfolderview";
import GeneralSettingsView from "../component/settings/general_settings";
import {aclPermissions, hasPermissions} from '../const/ACLPermissions';
import accesscontrol from './accesscontrol';
import ImportScansView from "./import_scans";
import ManagePermission from './managepermission';
import ScannerAnalysisSummary from "./scannerAnalysisSummary";
import OrganisationLevelVisiblePermissions from "./organisationLevelVisiblePermissions";
//DashBoard icons import
import {getDefaultEndpoint, openDefaultEndpoint} from 'utils/endpoint_utils';
import {ReactComponent as IconAdmin} from "../asset/dashboard/admin.svg";
import {ReactComponent as IconAllscan} from "../asset/dashboard/allScan.svg";
import {ReactComponent as IconCase} from "../asset/dashboard/case.svg";
import {ReactComponent as IconFolder} from "../asset/dashboard/folder.svg";
import {ReactComponent as IconLogout} from "../asset/dashboard/logout.svg";
import {ReactComponent as IconStatsDashboard} from "../asset/dashboard/statsdashboard.svg";
import {ReactComponent as IconValidation} from "../asset/dashboard/validation.svg";
import ManagePolicyView from "./managepolicy";
import ManagePolicyTable from "./managepolicytable";
import UserAccount from "./userAccount";

const {Sider, Content} = Layout;

// List of collapse menu items with key in index 0 and link_to in index 1
const collapse_menu_items = {
    "dashboard": ["scans", "/dashboard/"],
    "cases": ["cases", "/cases"],
    "clia_validations": ["clia", "/clia_validations"],
    "general_settings": ["general_settings", "/general_settings"],
    "import_scans": ["import_scans", "/import_scans"],
    "stats": ["stats", "/stats"],
    "scannerAnalysis": ["analysis", "/scannerAnalysis"],
    "devices": ["devices", "/devices"],
    "disks": ["disks", "/disks"],
    "thresholder": ["thresholder", "/thresholder"],
    "addtiledscan": ["addtiledscan", "/addtiledscan"],
    "services": ["services", "/services"],
    "accesscontrol": ["accesscontrol", "/accesscontrol"],
    "folders": ["folders", "/patient_folders/"],
    "morpho_chat": ["morpho_chat", "/morpho_chat/"],
}

export class Morpheus extends Component {

    constructor(props) {
        super(props);


        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);

        this.state = {
            collapsed: this.isMobile,
            sessionValid: true,
            isExpandedOpen: false,
            accountTooltipVisible: false,
            logoutTooltipVisible: false,
            showTOTPWarning: !isTrue(JSON.parse(localStorage.getItem('isTotpEnabled'))),
        };

        this.pollingTask = null
        this.is_superuser = isSuperuser()
        this.is_cloud = isCloud()
    }

    componentDidMount = () => {

        const currentPath = window.location.href;
        if (currentPath.includes(cookie.load('urlPath'))) {
            this.props.dispatch(loadMorpheusSetting())
            this.pollingTask = !this.is_cloud ? sagaMiddleware.run(watchForPollables, (this.props.ids_to_poll || [])) : null;
            this.debounceFunc = debounce(this.resizeListener, 400);
            window.addEventListener("resize", this.debounceFunc);
        } else {
            this.logout();
        }
    };

    //gifs to be placed in /media/scandrive/media/tour_images
    tourGuide = () => {
        setTimeout(() => {
            if (this.props.tourStatus?.tourActive) {
                tourGuideForDashboard()
            }
        }, 100)
    }

    resizeListener = () => {
        this.forceUpdate();
        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.is_cloud) {
            const ids_to_poll_unchanged = isEqual(prevProps.ids_to_poll, this.props.ids_to_poll)
            if (!prevProps.ids_to_poll || !ids_to_poll_unchanged) {
                if (this.pollingTask) this.pollingTask.cancel()
                this.pollingTask = sagaMiddleware.run(watchForPollables, (this.props.ids_to_poll || []))
            }
        }
        if (prevProps.firstName !== this.props.firstName) {
            this.getSideMenu()
        }

        if (prevProps.tourStatus?.tourActive !== this.props.tourStatus?.tourActive && isTrue(this.props.tourStatus?.tourActive)) {
            this.tourGuide();
        }

        if (prevProps.isTotpEnabled !== this.props.isTotpEnabled && isTrue(JSON.parse(localStorage.getItem('isTotpEnabled')))){
            this.handleCloseTOTPWarning();
        }
    }

    componentWillUnmount = () => {
        this.props.dispatch(stopPollingForPollables())
        if (this.pollingTask) this.pollingTask.cancel()

        window.removeEventListener("resize", this.debounceFunc);
    };

    checkSessionValidity = () => {
        if (!this.props.sessionValid) {
            let message = "We logged you out because you signed in somewhere else."
            let resolution = "Please Contact Administrator if you did not sign-in elsewhere";
            this.logout(message, resolution);
        }
    }

    toggle = () => {
        if (this.props.drawerCollapsed) {
            this.props.dispatch(openDrawer());
        } else {
            this.props.dispatch(closeDrawer());
        }
    };

    onCollapse = collapsed => {
        if (collapsed) {
            this.props.dispatch(closeDrawer());
        } else {
            this.props.dispatch(openDrawer());
        }
    };

    logout = (displayMessage = null, resolution = null) => {
        this.props.dispatch(logout(displayMessage, resolution));
    };

    goToAdminMode = () => {
        // If subdirectory being used, open remote URL as subdirectory url does not work currently
        if (isRunningFromSite()) {
            window.open(getRealRemoteURL("/admin/"), '_blank')
        } else {
            openInNewTab("/admin/")
        }
    }

    handleAccountMouseEnter = () => {
        if (this.props.drawerCollapsed) {
            this.setState({accountTooltipVisible: true});
        }
    };

    handleAccountMouseLeave = () => {
        this.setState({accountTooltipVisible: false});
    };

    handleLogoutMouseEnter = () => {
        if (this.props.drawerCollapsed) {
            this.setState({logoutTooltipVisible: true});
        }
    };

    handleLogoutMouseLeave = () => {
        this.setState({logoutTooltipVisible: false});
    };

    handleCloseTOTPWarning = () => {
        this.setState({ showTOTPWarning: false });
    };

    getSideMenu = () => {
        let urlParts = window.location.href.split('/');
        let component = '';
        const initialURLPart = window.location.href.split('?')[0];
        Object.entries(collapse_menu_items).forEach(([key, val]) => {
            if (initialURLPart.includes('scanners')) {
                component = "scanner-" + (urlParts.indexOf('scanners') !== -1 ? urlParts[urlParts.indexOf('scanners') + 1] : '');
            } else if (initialURLPart.includes(key)) {
                component = val[0];
            }
        })

        const createScannersList = (key, defaultPermission) =>
            hasPermissions([aclPermissions.view_scanner])
                ? <ScannersListComp key={key}/>
                : undefined;


        let offlineComponent = !this.is_cloud ?
            [
                createScannersList(
                    "scanners",
                    false,
                ),
            ] : undefined;

        const createLinkMenuItem = (key, icon, span, link_to, classname, defaultPermission) =>
            <Menu.Item key={key} className={classname}>
                <Link to={link_to}>
                    <span role={"img"} className={"anticon"}>{icon}</span>
                    <span style={{marginLeft: "10px"}}>{span}</span>
                </Link>
            </Menu.Item>

        const aboveL2 = document.documentElement.clientWidth > responsiveLayers.LEVEL_2;
        const firstname = isNull(this.props.firstName) || this.props.firstName === '' ? cookie.load('first_name') : this.props.firstName;

        return (
            <div className={'full-parent'}
                   style={{ position: 'absolute', top: 0, left: 0 }}>
                <Row style={{
                    height: "70px",
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <img
                        className={this.props.drawerCollapsed ? "logo-square" : "logo"}
                        src={this.props.drawerCollapsed ? MorphleLogoSquare : MorphleLogoBW}
                        alt={"logo"}
                        onClick={() => {
                            openDefaultEndpoint()
                        }}
                    />
                </Row>
                <Divider color={"white"}/>
                <Row
                    className={this.state.isExpandedOpen ? 'side-menu-overflow side-menu-height-expanded' : 'side-menu-overflow side-menu-height-collapsed'}
                    style={{display: "flex", flexDirection: "column", justifyContent: "flex-start"}}>
                    <Menu
                        mode="inline"
                        defaultOpenKeys={['scanners']}
                        defaultSelectedKeys={[component]}
                        selectedKeys={[component]}
                        className={"side-menu " + (this.props.drawerCollapsed ? '' : 'side-menu-border')}>
                        <Typography key="toggle" className={"aside-drawer"} onClick={this.toggle}
                                    style={{
                                        cursor: 'pointer',
                                        marginBottom: '20px',
                                        fontSize: '15px',
                                        width: '150px',
                                        fontWeight: 'bold',
                                        marginLeft: this.props.drawerCollapsed ? '35px' : '26px',
                                    }}>
                            {this.props.drawerCollapsed ? aboveL2 ? <DoubleRightOutlined/> : null :
                                <DoubleLeftOutlined/>}
                            <span style={{
                                marginLeft: '10px',
                                display: this.props.drawerCollapsed ? 'none' : 'inline-block'
                            }}>
                                    {"Collapse Menu"}
                                </span>
                        </Typography>
                        {hasPermissions([aclPermissions.folders_menu]) &&
                            createLinkMenuItem(
                                collapse_menu_items['folders'][0],
                                <IconFolder width={"24px"} height={"24px"}/>,
                                "Folders",
                                collapse_menu_items['folders'][1],
                                'patient-folders-forTour',
                                true,
                            )}
                        {hasPermissions([aclPermissions.cases_menu]) && createLinkMenuItem(
                            collapse_menu_items['cases'][0],
                            <IconCase width={"24px"} height={"24px"}/>,
                            (cookie.load("organisation_setting") || {})?.["case_collapse_menu_config"]?.["title"] || "Cases",
                            collapse_menu_items['cases'][1],
                            'cases-forTour',
                            true,
                        )}
                        {createLinkMenuItem(
                            collapse_menu_items['dashboard'][0],
                            <IconAllscan width={"24px"} height={"24px"}/>,
                            "All Scans",
                            collapse_menu_items['dashboard'][1],
                            'scans-forTour',
                            true,
                        )}
                        {hasPermissions([aclPermissions.ai_chat_app]) && createLinkMenuItem(
                            collapse_menu_items['morpho_chat'][0],
                            <SmartToyOutlinedIcon sx={{fontSize: 24}}/>,
                            "Morpho Chat",
                            collapse_menu_items['morpho_chat'][1],
                            'morpho-chat-forTour',
                            true,
                        )}
                        {hasPermissions([aclPermissions.clia_menu]) && createLinkMenuItem(
                            collapse_menu_items['clia_validations'][0],
                            <IconValidation width={"24px"} height={"24px"}/>,
                            "Clia Validations",
                            collapse_menu_items['clia_validations'][1],
                            'clia-forTour',
                            this.is_superuser,
                        )}
                        {offlineComponent}
                        {hasPermissions([aclPermissions.general_setting_menu]) && createLinkMenuItem(
                            collapse_menu_items['general_settings'][0],
                            <SettingOutlined width={"24px"} height={"24px"}/>,
                            "Settings",
                            collapse_menu_items['general_settings'][1],
                            'export_settings-forTour',
                            true,
                        )}
                        {!isCloud() && hasPermissions([aclPermissions.import_scan_menu]) && createLinkMenuItem(
                            collapse_menu_items['import_scans'][0],
                            <ImportOutlined width={"24px"} height={"24px"}/>,
                            "Import Scans",
                            collapse_menu_items['import_scans'][1],
                            'import_scans-forTour',
                            false,
                        )}
                        {!isCloud() && hasPermissions([aclPermissions.stats_info_menu]) && createLinkMenuItem(
                            collapse_menu_items['stats'][0],
                            <IconStatsDashboard width={"24px"} height={"24px"}/>,
                            "Scanning Stats",
                            collapse_menu_items['stats'][1],
                            'stats-forTour',
                            true,
                        )}
                        {this.is_superuser && isCloud() && createLinkMenuItem(
                            collapse_menu_items['scannerAnalysis'][0],
                            <BarChartOutlined width={"24px"} height={"24px"}/>,
                            "Scanner Analysis",
                            collapse_menu_items['scannerAnalysis'][1],
                            'analysis-forTour',
                            this.is_superuser
                        )}
                        {hasPermissions([aclPermissions.devices_menu]) && createLinkMenuItem(
                            collapse_menu_items['devices'][0],
                            <ApartmentOutlined width={"24px"} height={"24px"}/>,
                            "Devices",
                            collapse_menu_items['devices'][1],
                            'devices-forTour',
                            true,
                        )}
                        {!isCloud() && hasPermissions([aclPermissions.disk_info_menu]) && createLinkMenuItem(
                            collapse_menu_items['disks'][0],
                            <DatabaseOutlined width={"24px"} height={"24px"}/>,
                            "Disks Info",
                            collapse_menu_items['disks'][1],
                            'disks_info-forTour',
                            true,
                        )}
                        {hasPermissions([aclPermissions.manage_users_menu]) && createLinkMenuItem(
                            collapse_menu_items['accesscontrol'][0],
                            <TeamOutlined width={"24px"} height={"24px"}/>,
                            "Manage Users",
                            collapse_menu_items['accesscontrol'][1],
                            'manageusers-forTour',
                            true,
                        )}
                        {this.is_superuser ?
                            <Menu.Item key="admin" onClick={this.goToAdminMode}>
                                <div className={"dashboard-icons"}>
                                    <span role={"img"} className={"anticon"}>
                                        <IconAdmin width={"24px"} height={"24px"}/>
                                    </span>
                                    <span style={{marginLeft: "10px"}}>Admin Mode</span>
                                </div>
                            </Menu.Item> : undefined}
                    </Menu>
                </Row>
                <div className={this.state.isExpandedOpen ? 'footer-sidebar footer-sidebar-height-maximized' : 'footer-sidebar footer-sidebar-height-minimized'}>
                    <Divider color={"white"} style={{opacity: '0.2'}}/>
                    {this.props.drawerCollapsed ?
                        <h1 style={{color: "white", fontSize: "14px", width: "80px", marginTop: "7px", paddingLeft: "24px"}}>v6.4.1</h1> :
                        <h1 style={{color: "white", fontSize: "14px", marginTop: "7px", paddingLeft: "24px"}}> Morphle IMS v6.4.1</h1>}
                    <Divider color={"white"} style={{opacity: '0.2'}}/>
                    <div className={`user-info`} style={{width: this.props.drawerCollapsed ? '80px' : null}}>
                        {this.state.isExpandedOpen && (
                            <div style={{marginLeft: 10}}>
                                <Tooltip title="Account" placement="right"
                                    // visible={this.props.drawerCollapsed}>
                                         visible={this.state.accountTooltipVisible}>
                                    <Link to="/user_account/" className={'links-btn'} onClick={this.toggleExpand}
                                          onMouseEnter={this.handleAccountMouseEnter}
                                          onMouseLeave={this.handleAccountMouseLeave}>
                                        <span role={"img"} className={"anticon"}>
                                            <UserOutlined width={"24px"} height={"24px"}/>
                                        </span>
                                        {!this.props.drawerCollapsed &&
                                            <span style={{fontSize: "15px", marginLeft: 10}}>Account</span>}
                                    </Link>
                                </Tooltip>
                                <Tooltip title="Logout" placement="right" overlayStyle={{left: '84px'}}
                                         visible={this.state.logoutTooltipVisible}>
                                    <div onClick={this.logout} className={'links-btn'} style={{cursor: 'pointer'}}
                                         onMouseEnter={this.handleLogoutMouseEnter}
                                         onMouseLeave={this.handleLogoutMouseLeave}>
                                        <span role={"img"} className={"anticon"}>
                                            <IconLogout width={"24px"} height={"24px"}/>
                                        </span>
                                        {!this.props.drawerCollapsed &&
                                            <span style={{fontSize: "15px", marginLeft: 10}}>Logout</span>}
                                    </div>
                                </Tooltip>
                            </div>
                        )}
                        <div className={'user-menu'} onClick={this.toggleExpand}>
                            <button className={'user-btn'}>
                                <Avatar {...stringForAvatar(firstname, false)} size={36}/>
                                {!this.props.drawerCollapsed && (
                                    <span className={'user-name'}>
                                        {firstname && firstname.length > 7 ? firstname.slice(0, 7) + '..' : firstname}
                                    </span>
                                )}
                                {!this.props.drawerCollapsed && (this.state.isExpandedOpen ?
                                    <CaretDownOutlined className={'expand-icon'}/> :
                                    <CaretUpOutlined className={'expand-icon'}/>)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    toggleExpand = () => {
        this.setState((prevState) => ({
            isExpandedOpen: !prevState.isExpandedOpen,
        }));
    };

    render() {
        if (!this.props.morpheusSetting.sorting?.slide_order_by)
            return <LoadingText/>;
        let mobileHeader = null;
        let sideMenu = null;
        let status = this.props.authStat;

        if (this.isMobile) {
            mobileHeader = <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}
                                  className={"full-width"} height={"58px"} bgcolor={"background.paper"}>
                <Stack spacing={2} justifyContent={"flex-start"} alignItems={"center"} direction={"row"}
                       divider={<Divider orientation="vertical" flexItem/>}>
                    <img src={MorphleLogoSquare} className={"morphle-header-logo"}
                         style={{width: "50px", height: "auto", cursor: 'pointer', marginTop: 10}}
                         onClick={(event) =>
                             openEndPoint("/dashboard/", event.ctrlKey)}
                         alt={"MorphleBWLogo"}
                         onAuxClick={() => openEndPoint("/dashboard/", true)}
                    />
                </Stack>
                <Stack spacing={1} alignItems="center" marginRight={1}
                       direction={"row"} justifyContent="flex-end"
                       divider={<Divider orientation="vertical" flexItem/>}>
                    <Typography direction="row">
                        Logged in as {cookie.load('first_name')}
                    </Typography>
                </Stack>
                <Stack spacing={1} alignItems="center" marginRight={1}>
                    <MuiButton key="7" onClick={this.logout}
                               sx={{backgroundColor: '#f35656', width: '30px', minWidth: '30px', px: 0.5}}>
                        <LogoutOutlined style={{color: '#fff'}}/>
                    </MuiButton>
                </Stack>
            </Stack>
        } else {
            if (cookie.loadAll().superuser === true ? document.documentElement.clientWidth < responsiveLayers.LEVEL_1 :
                document.documentElement.clientWidth < responsiveLayers.LEVEL_2)
                this.props.dispatch(closeDrawer());
            sideMenu = <Sider className="sider" collapsed={this.props.drawerCollapsed} onCollapse={this.onCollapse}>
                {this.getSideMenu()}
            </Sider>
        }
        return (
            <Spin spinning={this.props.uiBusy} tip={this.props.busyMessage} wrapperClassName={'full-parent'}>
                <Layout id="outer-container" className={"full-parent"}>
                    {sideMenu}
                    <Layout className="main-content">
                        {mobileHeader}
                        <Content id="content" className='main-content'>
                            <PrivateRoute path={"/dashboard"} component={AllScansView} status={status}/>
                            <PrivateRoute path={"/morpho_chat"} component={MorphoChatDashboard} status={status}/>
                            <PrivateRoute path={"/scannerflow/:id/scan/:stage"}
                                          component={ScanWorkflowNew} status={status}/>
                            <PrivateRoute path={"/scannerflow/:id/blood-scan/:stage"}
                                          component={BloodWorkflow} status={status}/>
                            <PrivateRoute path={"/scanners/:id/:progress_stage?"}
                                          component={ScannerView} status={status}/>
                            <PrivateRoute path={"/patient_folders/"} component={PatientFolderView} status={status}/>
                            <PrivateRoute path={"/patient_folder/:id/"} component={PatientFolder} status={status}/>
                            <PrivateRoute path={"/addpatientfolder"} component={AddPatientFolder} status={status}/>
                            <PrivateRoute path={"/cases"} component={CasesView} status={status}/>
                            <PrivateRoute path={"/case/:id/"} component={SingleCaseView} status={status}/>
                            <PrivateRoute path={"/addcase/"} component={AddCaseView} status={status}/>
                            <PrivateRoute path={"/manageusers/"} component={ManageUsers} status={status}/>
                            <PrivateRoute path={"/accesscontrol/"} component={accesscontrol} status={status}/>
                            <PrivateRoute path={"/adduser/"} component={AddUserView} status={status}/>
                            <PrivateRoute path={"/managepolicy/"} component={ManagePolicyTable} status={status}/>
                            <PrivateRoute path={"/createpolicy/"} component={ManagePolicyView} status={status}/>
                            <PrivateRoute path={"/editpolicy/:id"} component={ManagePolicyView} status={status}/>
                            <PrivateRoute path={"/edituser/:id/"} component={EditUserView} status={status}/>
                            <PrivateRoute path={"/orgperms/"} component={OrganisationLevelVisiblePermissions}
                                          status={status}/>
                            <PrivateRoute path={"/manage-permissions/:name/:type"} component={ManagePermission}
                                          status={status}/>
                            <PrivateRoute path={"/settings/:id/"} component={SettingsView} status={status}/>
                            <PrivateRoute path={"/c240_control_panel/:id"} component={C240ControlPanelView}
                                          status={status}/>
                            <PrivateRoute path={"/scanning_profile"} component={ScanningProfileView} status={status}/>
                            <PrivateRoute path={"/devices"} component={Devices} status={status}/>
                            <PrivateRoute path={"/import_scans"} component={ImportScansView} status={status}/>
                            <PrivateRoute path={"/disks"} component={Disks} status={status}/>
                            <PrivateRoute path={"/stats"} component={StatsDashboard} status={status}/>
                            <PrivateRoute path={"/live_plot/:path/"} component={LivePlot} status={status}/>
                            <PrivateRoute path={"/scannerAnalysis"} component={ScannerAnalysis} status={status}/>
                            <PrivateRoute path={"/scannerAnalysisSummary"} component={ScannerAnalysisSummary}
                                          status={status}/>
                            <PrivateRoute path={"/bloodpreview/:device_id/:slot_id/:id/"}
                                          component={BloodPreviewSettingsComp} status={status}/>
                            <PrivateRoute path={"/general_settings"} component={GeneralSettingsView} status={status}/>
                            <PrivateRoute path={"/clia"} component={CliaView} status={status}/>
                            <PrivateRoute path={"/addvalidation/"}
                                          component={AddValidationView} status={status}/>
                            <PrivateRoute path={"/clia_barrier/"} component={CliaBarrier} status={status}/>
                            <PrivateRoute path={"/clia_case/:id/"} component={SingleCaseView} status={status}/>
                            <PrivateRoute path={"/clia_validations"}
                                          component={validationStudies} status={status}/>
                            <PrivateRoute path={"/clia_validation/:id"}
                                          component={SingleValidationView} status={status}/>
                            <PrivateRoute path={"/summary/:id"} component={SummaryView} status={status}/>
                            <PrivateRoute path={"/user_account/"} component={UserAccount} status={status}/>
                            <Route exact path={"/"} render={() => <Redirect to={getDefaultEndpoint()}/>}/>
                            {checkAbstractAppPermission(showMfaAlert) && this.state.showTOTPWarning && (
                             <Alert
                             message="Security Notice"
                             description={
                               <div>
                                 You have not enabled Multi-Factor Authentication for your account.<br/> To Enable MFA{' '} 
                                 <Link to="/user_account" onClick={this.handleCloseTOTPWarning}>
                                    click here
                                 </Link>
                               </div>
                             }
                             type="warning"
                             showIcon
                             closable
                             onClose={this.handleCloseTOTPWarning}
                             style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 999 }}
                           />
                          )}
                        </Content>
                    </Layout>
                </Layout>
            </Spin>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        morpheusSetting: state.morpheusSettingReducer,
        sessionValid: state.sessionStatusReducer.sessionValid,
        drawerCollapsed: state.dashboardReducer.drawerCollapsed,
        uiBusy: state.utilsReducer.uiBusy,
        busyMessage: state.utilsReducer.busyMessage,
        popupProps: state.contextMenuReducer.popupProps,
        ids_to_poll: state.dashboardReducer.ids_to_poll,
        authStat: state.loginAlerts.authVerificationStatus,
        isTotpEnabled: state.loginAlerts.isTotpEnabled,
        tourStatus: state.websiteTourReducer,
        deviceList: state.deviceAlert.deviceData,
        firstName: state.loginAlerts.firstName,
    };
};

export default connect(mapStateToProps)(Morpheus);
